import React, { useLayoutEffect, useState, useEffect, useRef } from 'react'
import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    Pager,
    Paging,
    SearchPanel,
} from "devextreme-react/data-grid";
import { Button, DateBox, SelectBox } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import Popup from "devextreme-react/popup";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { IOMService } from '../../../apis/apiServices/InterOfficeMemo(IOM)'
import { pendingCount } from '../../../redux/IOMPendingCount';
import { SetSessionItem } from '../../../helper/appsession';
import { ProjectService } from '../../../apis/apiServices/Project'

export default function PendingIOMComponent(props) {

    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
    });
    const [filterErrors, setFilterErrors] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
    });
    const dispatch = useDispatch();
    const [iomList, setIOMList] = useState(null);
    const [pendingIOMCount, setPendingIOMCount] = useState(null);
    const [filteredList, setFilteredList] = useState(null);
    const user = useSelector((state) => state.user.data);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [error, setError] = useState("");
    const [rowIOMId, setIOMId] = useState("");
    const [projectDropdownData, setProjectDropdownData] = useState(null);


    // const getProjectDropdownData = async () => {
    //     //debugger;
    //     try {
    //         let body = {}
    //         const response = await ProjectService.getProjectDropdown(body)
    //         setProjectDropdownData(response?.data);
    //     } catch (error) {
    //         console.log("Error getProjectList===>", error);
    //     }
    // }

    const getProjectDropdownData = async () => {
        try {
            const response = await ProjectService.getProjectByUserId(user?.userId)
            setProjectDropdownData(response?.data);
        } catch (error) {
            console.log("Error getProjectDropdownData===>", error);
        }
    }

    const getIOMList = async (isIgnoreFilters) => {
        //debugger;
        try {
            let body = {
                UserId: user.userId,
                fromDate: (filters?.fromDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.fromDate) : null,
                toDate: (filters?.toDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.toDate) : null,
                projectId: (filters?.projectId && isIgnoreFilters !== true) ? filters?.projectId : 0,
                isMyTask: true
            }
            const response = await IOMService.getIOMList(body)
            const filteredData = response?.data?.filter(item =>
                (item?.nextUserId === user?.userId || item?.reviewerUserId === user?.userId) &&
                item?.iomStatusId !== 4 &&
                item?.iomStatusId !== 9 &&
                item?.iomStatusId !== 8 &&
                item?.isReviewed === null
            );
            const filteredCount = filteredData?.length;
            setPendingIOMCount(filteredCount);
            dispatch(pendingCount(filteredCount));
            SetSessionItem("pendingCount", filteredCount);
            setIOMList(filteredData);
            // getFilteredList([8, 4], response?.data)
        } catch (error) {
            console.log("Error getIOMList===>", error);
        }
    }

    const handleFilterChange = (key, value) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    const ConvertDateToddMMyyyy = (date) => {
        if (!date) return "";

        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;

        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }
    const ConvertddMMyyyyToDate = (dateStaring) => {
        if (!dateStaring) return "";
        let date = new Date(dateStaring)
    }

    useEffect(() => {
        getIOMList();
    }, [])

    // useEffect(() => {
    //     if (iomLatestPendingCount === 0 && !hasReloaded.current) {
    //         hasReloaded.current = true; // set the flag
    //         window.location.reload();
    //     }
    // }, [iomLatestPendingCount]);

    const handleRemarksChange = (e) => {
        setRemarks(e.value);
        if (error) setError(""); // clear error on typing
    };

    const handleSubmit = () => {
        if (!remarks) {
            setError("Please enter remarks");
            return;
        }
        setError("");
        setIsDeleteModalVisible(false);
        deleteIoM();  // Now call your existing function
    };

    const deleteIoM = async () => {
        //e.preventDefault();
        if (!remarks.trim()) {
            setError("Please enter remarks");
            return;
        }
        setIsDeleteModalVisible(false);
        setRemarks("");

        let body = {
            userId: user.userId,
            //updatedOn: new Date().toISOString(),
            remarks: remarks || "",
            //IsRecommededUser: user?.userId === iomData?.recommendId ? true : false,
            iomId: rowIOMId || 0,
        };
        const response = await IOMService.deleteIOM(body);
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            );
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => { navigate(`/inter-office-memo`) });
    };

    const getFilteredList = (iomStatusIds, newIomList) => {

        let newFilteredList = newIomList
            ? newIomList?.filter(iom => iomStatusIds?.includes(iom?.iomStatusId))
            : iomList?.filter(iom => iomStatusIds?.includes(iom?.iomStatusId))

        setFilteredList(newFilteredList);
    }
    useLayoutEffect(() => {
        const title = pendingIOMCount > 0 ? `My Tasks (${pendingIOMCount})` : "My Tasks";
        document.querySelector("#pageTitle").innerHTML = title;
        getIOMList();
        getProjectDropdownData();
    }, [pendingIOMCount]);

    return (<>
        <div className="content">
            {/* Filters */}
            <div className="card filter">
                <div className="card-body">
                    <div className="row">
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>
                                From <span className="text-danger">*</span>
                            </label>
                            <DateBox
                                placeholder="Select date"
                                value={filters?.fromDate}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("fromDate", e?.value)
                                }
                                }
                                displayFormat="dd/MM/yyyy"
                            />
                            {filterErrors?.fromDate && <span className="error invalid-feedback">{filterErrors?.fromDate}</span>}
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>
                                To <span className="text-danger">*</span>
                            </label>
                            <DateBox
                                placeholder="Select date"
                                value={filters?.toDate}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("toDate", e?.value)
                                }}
                                displayFormat="dd/MM/yyyy"
                            />
                            {filterErrors?.toDate && <span className="error invalid-feedback">{filterErrors?.toDate}</span>}
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>
                                Project <span className="text-danger"></span>
                            </label>
                            <SelectBox
                                //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                dataSource={projectDropdownData}
                                valueExpr="id"
                                displayExpr="name"
                                className="form-control"
                                placeholder="Select"
                                searchEnabled
                                showClearButton={false}
                                value={filters?.projectId}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("projectId", e?.value)
                                }}
                            />
                            {/* {filterErrors?.toDate && <span className="error invalid-feedback">{filterErrors?.toDate}</span>} */}
                        </div>

                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label style={{ display: "block" }}>&nbsp;</label>
                            <button
                                className="btn btn-primary btn-sm mt-2 mr-2"
                                title='Filter'
                                tooltip='Filter'
                                onClick={getIOMList}
                            >
                                <Icon className='iconify-size mr-1' icon="hugeicons:filter" />
                                Filter
                            </button>
                            <button
                                className="btn btn-outline-primary btn-sm mt-2"
                                title='Clear'
                                tooltip='Clear'
                                onClick={() => {
                                    setFilters(prevState => {
                                        return {
                                            ...prevState,
                                            fromDate: "",
                                            toDate: "",
                                            projectId: "",
                                        }
                                    })
                                    getIOMList(true);
                                }}
                            >
                                <Icon className='iconify-size mr-1' icon="hugeicons:eraser" />
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='card'>
                <div class="card-body">
                    <div class="tab-content" id="custom-tabs-tabContent">
                        <DataGrid
                            dataSource={iomList}
                            className='iom-grid'
                            columnAutoWidth
                            showBorders
                            showColumnLines={false}
                            showRowLines={true}
                            allowFiltering
                            columnHidingEnabled
                            onToolbarPreparing={(e) => {
                                e.toolbarOptions.items.unshift({
                                    location: 'before',
                                    widget: 'dxButton',
                                    options: {
                                        icon: 'refresh',
                                        text: 'Refresh',
                                        type: 'default',
                                        stylingMode: 'outlined',
                                        onClick: () => getIOMList()
                                    }
                                });
                            }}
                        >
                            <Column
                                width="80px"
                                cellRender={(cellData) => {
                                    const rowData = cellData?.data;
                                    return (
                                        <>
                                            {/* View */}
                                            <span title='View'>
                                                <Icon
                                                    title="View"
                                                    className='iconify-size'
                                                    icon="solar:document-text-outline"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                        navigate("/iom-preview", { state: { iomId: rowData?.iomId, isPreviewOnly: true, fromPendingPage: true } })
                                                    }
                                                />
                                            </span>
                                            {/* Edit */}
                                            {(rowData?.nextUserId === user?.userId && rowData?.toUserId !== user?.userId)
                                                ? (
                                                    <span title="Edit">
                                                        <Icon
                                                            title="Edit"
                                                            className='iconify-size mr-1'
                                                            icon="solar:pen-line-duotone"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                if (rowData?.isManual) {
                                                                    navigate("/new-inter-office-memo-old", { state: rowData });
                                                                } else {
                                                                    navigate("/new-inter-office-memo", { state: rowData });
                                                                }
                                                            }}

                                                        />
                                                    </span>
                                                ) : (
                                                    <span>
                                                        <Icon
                                                            title="Edit"
                                                            className='iconify-size'
                                                            icon="solar:pen-line-duotone"
                                                            style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                        />
                                                    </span>
                                                )}
                                            {/* Delete */}
                                            {/* {rowData?.createdByUserId === user?.userId && (rowData?.iomStatusId === 8 || rowData?.iomStatusId === 4) ? (
                                                    <span title="Delete">
                                                        <Icon
                                                            title="Delete"
                                                            className='iconify-size'
                                                            icon="fluent:delete-32-regular"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                setIOMId(rowData?.iomId);
                                                                setIsDeleteModalVisible(true);
                                                                navigate("/pending-ioms");
                                                            }}
                                                        />
                                                    </span>
                                                ) : (
                                                    <span>
                                                        <Icon
                                                            title="Delete"
                                                            className='iconify-size'
                                                            icon="fluent:delete-32-regular"
                                                            style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                        />
                                                    </span>
                                                )} */}

                                        </>
                                    );
                                }}
                            />
                            <Column dataField="serial_no" caption="IOM No." width='230px' allowFiltering={false} />
                            {/* <Column
                                dataField="nextUserStatusText"
                                caption="Status"
                                cellRender={(e) => {
                                    let color = '#28A745';
                                    if (e.data?.nextUserStatusId === 4) color = 'gray';
                                    else if (e.data?.nextUserStatusId === 1) color = '#ff9800';
                                    else if (e.data?.nextUserStatusId === 2) color = '#FF9800';
                                    else if (e.data?.nextUserStatusId === 3) color = 'orange';
                                    else if (e.data?.nextUserStatusId === 7) color = '#ff9800';

                                    return (
                                        <div>
                                            {(e.data?.iomStatusId === 8) ? (
                                                <span style={{ color: '#6C757D' }}>Drafted</span>
                                            ) : (e.data?.iomStatusId === 4) ? (
                                                <span style={{ color: '#DC3545' }}>Rejected</span>
                                            ) : (
                                                <span style={{ color }}>{e.value ?? "Approved"}</span>
                                            )}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                                                {e.data?.nextUser?.trim() === "" ? e.data?.lastUpdatedByUser : e.data?.nextUser}
                                            </div>
                                        </div>
                                    );
                                }}
                            /> */}
                            <Column
                                caption="From"
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data.fromUser}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.fromUserDepartment}</div>
                                    </div>
                                )}
                            />
                            <Column
                                caption="To"
                                dataField="toUser"
                                allowFiltering={false}
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data.toUser}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.toUserDepartment}</div>
                                    </div>
                                )}
                            />
                            <Column
                                dataField="subject"
                                caption="Subject"
                                allowFiltering={false}
                                cellRender={(cellData) => (
                                    <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                                        {cellData.value}
                                    </div>
                                )}
                            />
                            <Column dataField="projectName" caption="Project" allowFiltering={false} />
                            <Column
                                dataField="iomDate"
                                allowFiltering={false}
                                caption="Created On"
                                width="120px"
                                cellRender={(e) => {
                                    const date = new Date(e.data.iomDate);
                                    return (
                                        <>
                                            {date.toLocaleDateString('en-GB')}
                                            <div style={{ fontSize: '11px', color: '#b1b1b1' }}>
                                                {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            </div>
                                        </>
                                    );
                                }}
                            />
                            <Column
                                dataField="lastUpdatedOn"
                                caption="Last Updated"
                                allowFiltering={false}
                                width="150px"
                                cellRender={(e) => {
                                    if (!e.data.lastUpdatedOn) return null;
                                    const date = new Date(e.data.lastUpdatedOn);
                                    return (
                                        <div>
                                            {date.toLocaleDateString('en-GB')}&nbsp;
                                            {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data.lastUpdatedByUser}</div>
                                        </div>
                                    );
                                }}
                            />


                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} highlightCaseSensitive width={240} placeholder="Search..." />
                            <Paging defaultPageSize={15} />
                            <Pager
                                visible={true}
                                allowedPageSizes={[10, 15, 20, 50, 100]}
                                showPageSizeSelector={true}
                                showInfo={true}
                                showNavigationButtons={true}
                            />
                            <Export enabled={false} fileName="IOM" />
                        </DataGrid>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </div>
        <Popup
            visible={isDeleteModalVisible}
            onHiding={() => setIsDeleteModalVisible(false)}
            dragEnabled={false}
            showTitle={true}
            title="Delete"
            height="auto"
            weight="auto"
            className='custom-modal-popup'
        >
            <div className='popup-body'>
                <label>Remark <span className="text-danger">*</span></label>
                <div className='form-group'>
                    <TextArea
                        value={remarks}
                        onValueChanged={handleRemarksChange}
                        height={90}
                        placeholder="Type your remarks..."
                    />
                    {error && (
                        <div style={{ color: "red", marginTop: 5 }}>{error}</div>
                    )}
                </div>
                <div className='text-right'>
                    <Button icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsDeleteModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleSubmit}
                        className="btn btn-primary btn-sm"
                    />

                </div>
            </div>
        </Popup>
    </>
    )
}





